import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="w-full bg-background py-12 border-t border-border">
      <div className="container px-4 mx-auto">
        <div className="flex flex-col tablet:flex-row laptop:flex-row desktop:flex-row items-center justify-between gap-6">
          <Link to="/">
            <span className="font-funnel font-bold text-2xl text-foreground">
              qwip
            </span>
          </Link>

          <a
            href="https://apps.apple.com/app/qwip/id6761749249"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform hover:scale-105"
            aria-label="Download qwip on the App Store"
          >
            <img
              src="/badges/app-store-badge.svg"
              alt="Download on the App Store"
              className="h-10 w-auto"
            />
          </a>

          <div className="flex items-center gap-3">
            <a 
              href="https://instagram.com/qwip.co.uk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <Instagram size={20} />
            </a>
            <a 
              href="https://linkedin.com/company/qwip-pods" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <Linkedin size={20} />
            </a>
            <p className="text-muted-foreground text-base">
              © 2025 qwip ltd.
            </p>
          </div>

          <div className="flex items-center gap-6">
            <Link 
              to="/privacy-policy" 
              className="text-muted-foreground hover:text-foreground text-sm transition-colors"
            >
              Privacy
            </Link>
            <Link 
              to="/terms" 
              className="text-muted-foreground hover:text-foreground text-sm transition-colors"
            >
              Terms
            </Link>
            <a 
              href="mailto:zain@qwip.co.uk" 
              className="text-muted-foreground hover:text-foreground text-sm transition-colors"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;